import { FormControl, MenuItem, Select } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { Leads } from '../../api/Endpoints/Leads';

const normalizeLabel = (label) => ({
    id: label?.id,
    title: label?.title || label?.name || 'Label',
    bg_color: label?.bg_color || '#e0e0e0',
    text_color: label?.text_color || '#333',
});

export default function LabelSelector({ id, currentLabel = [], labelOptions = [], func }) {
    const normalizedOptions = useMemo(
        () => (labelOptions || []).map(normalizeLabel),
        [labelOptions]
    );

    const selectedFromRow = useMemo(() => {
        if (!Array.isArray(currentLabel) || currentLabel.length === 0) return null;
        return normalizeLabel(currentLabel[0]);
    }, [currentLabel]);

    const [selectedLabelId, setSelectedLabelId] = useState('');

    useEffect(() => {
        setSelectedLabelId(selectedFromRow?.id || '');
    }, [selectedFromRow?.id]);

    const selectedLabel = useMemo(() => {
        if (!selectedLabelId) return selectedFromRow;
        return normalizedOptions.find((opt) => opt.id === selectedLabelId) || selectedFromRow;
    }, [normalizedOptions, selectedFromRow, selectedLabelId]);

    const handleChange = async (event) => {
        const nextLabelId = event.target.value;
        const payload = {
            id,
            labels_id: nextLabelId ? [nextLabelId] : null, // single label only
        };

        try {
            await Leads.update(payload);
            setSelectedLabelId(nextLabelId);
            toast.success('Label Successfully Updated', { autoClose: 1000 });
            func && func();
        } catch (err) {
            toast.error(
                err?.data?.message || err?.response?.data?.message || 'Unable to update label',
                { autoClose: 1200 }
            );
        }
    };

    return (
        <FormControl fullWidth size="small">
            <Select
                className="btn-rds"
                value={selectedLabelId || ''}
                onChange={handleChange}
                displayEmpty
                sx={{
                    borderRadius: '999px',
                    backgroundColor: selectedLabel?.bg_color || '#f5f5f5',
                    color: selectedLabel?.text_color || '#666',
                    fontSize: '11px',
                    minHeight: '30px',
                    '& .MuiSelect-select': {
                        py: 0.5,
                        px: 1.2,
                        textAlign: 'center',
                    },
                }}
                renderValue={(value) => {
                    if (!value) return 'No Label';
                    return selectedLabel?.title || 'Label';
                }}
            >
                <MenuItem value="">
                    No Label
                </MenuItem>
                {normalizedOptions.map((option) => (
                    <MenuItem
                        key={option.id}
                        value={option.id}
                        sx={{
                            backgroundColor: option.bg_color,
                            color: option.text_color,
                            ':hover': { backgroundColor: option.bg_color, opacity: 0.92 },
                        }}
                    >
                        {option.title}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
